import React from "react";
import {
  Popover,
  PopoverSurface,
  PopoverTrigger,
  TableCellLayout,
} from "@fluentui/react-components";

const CustomPopover = ({
  children,
  icon,
  width = null,
  minWidth = null,
  height = null,
  status,
  PopSurfaceClass,
  id = null,
  onOpenChange = null,
  inline = false,
}) => {
  return (
    <Popover
      positioning="below-start"
      open={status}
      id={id}
      onOpenChange={onOpenChange}
      inline={inline}
    >
      <PopoverTrigger disableButtonEnhancement>
        <TableCellLayout media={icon} />
      </PopoverTrigger>

      <PopoverSurface
        tabIndex={-1}
        style={{ minWidth: minWidth, width: width, height: height }}
        className={PopSurfaceClass}
      >
        {children}
      </PopoverSurface>
    </Popover>
  );
};

export default CustomPopover;
